/**
 * Standardized props for "this control is deferred to V2" placeholders.
 *
 * V1 ships only Home / Map / Rankings. The other three pages (Detail /
 * Compare / Providers) and a couple of footer / glossary actions show up
 * in the UI as visible-but-inert markers so users see what's coming.
 *
 * The visual treatment differs per site (tab cell in SectionNav, inline
 * list item in Footer, pill in DataViews CTA), so we don't share a
 * component — but the a11y props should be identical everywhere.
 *
 * Spread `{...V2_PLACEHOLDER_PROPS}` onto the inert element to keep
 * screen-readers consistent and the "Coming in V2" tooltip uniform.
 */
export const V2_PLACEHOLDER_PROPS = {
  'aria-disabled': true,
  title: 'Coming in V2',
} as const;
